import styled from 'styled-components'

export const ModalInner = styled.div`
  min-width: 768px;
  //max-width: 768px;
  top: 0.5em;
  z-index: 50;
`

export const Animation = styled.div`
  &.modal--animated {
    opacity: 0.1;
    transform: translateY(5em);
    transition: all 0.2s ease-in-out;
  }
  &.modal--animated > div > button {
	outline: none;
  }

  &.modal--animated.has-entered {
    opacity: 1;
    transform: translateY(0);
  }
`
